<p-dialog
  [(visible)]="visible"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [draggable]="false"
  [blockScroll]="true"
  [resizable]="false"
  (onHide)="closeModal()"
>
  <ng-template pTemplate="closeicon">
    <span class="closeicon pi pi-times"></span>
  </ng-template>
  <ng-template pTemplate="header">
    {{ 'animalEdit.move.headline' | transloco }}
  </ng-template>
  <ng-template pTemplate="content">
    <div class="flex flex-col">
      <p-message severity="info">
        <div class="ml-2">
          <p class="mb-1">{{ 'animalEdit.move.info' | transloco }}</p>
          <p>{{ 'animalEdit.move.consequences' | transloco }}</p>
          <ol class="ml-1">
            <li>{{ 'animalEdit.move.consequencesList.animal' | transloco }}</li>
            <li>{{ 'animalEdit.move.consequencesList.animalBookNumber' | transloco }}</li>
            <li>{{ 'animalEdit.move.consequencesList.animalOrigin' | transloco }}</li>
            <li>{{ 'animalEdit.move.consequencesList.animalWhereabout' | transloco }}</li>
          </ol>
        </div>
      </p-message>
      <p-panel>
        <div class="flex flex-wrap gap-4">
          <div class="flex-auto">
            <p-inputgroup>
              <p-iftalabel>
                <label for="animalShelter" class="mb-2 d-block">{{ 'animalEdit.move.shelter' | transloco }}</label>
                <p-select
                  appendTo="body"
                  id="animalShelter"
                  [options]="shelters"
                  [filter]="true"
                  [showClear]="false"
                  [optionLabel]="'title'"
                  [dataKey]="'id'"
                  [(ngModel)]="selectedShelter"
                  [ngModelOptions]="{standalone: true}"
                />
              </p-iftalabel>
            </p-inputgroup>
          </div>
          <div class="flex-auto">
            <app-custom-date-picker
              id="selectedDate"
              [label]="'animalEdit.move.date'"
              [rawInput]="selectedDate ? (selectedDate | date:'yyyy-MM-dd') : null"
              (valueChange)="selectedDate = $event"
              [required]="true"
            ></app-custom-date-picker>
          </div>
        </div>
      </p-panel>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex items-center gap-2">
      <div class="flex-1 text-center">
        <span class="required">* {{ 'animalEdit.general.required' | transloco }}</span>
      </div>
      <div>
        <p-button
          (click)="closeModal()"
          label="{{ 'modal.cancel' | transloco }}"
          icon="pi pi-times"
          [text]="true"
        />
        <p-button
          (click)="saveChanges()"
          [disabled]="!isMoveValid"
          label="{{ 'modal.save' | transloco }}"
          icon="pi pi-save"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>
